(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .directive('hcChart', function () {
        return {
          restrict: 'E',
          controller : 'HighChartsCtrl as vm',
          transclude: true,
          bindToController: true,
          templateUrl : 'StandardReports/HighCharts/HighCharts.tmpl.html',
          scope: {
            getData: '&', // callback function to get formatted API data
            options: '=', // options to build chart
            chartDataOptions: '&', // callback function to populate chart options which require data
            setParentValues: '&?' // callback function to set values in parent vm which require data
          },
          link: function (scope, element) {
            var container = element[0].querySelector('#highchart-container');

            scope.vm.onLoad(container);

            scope.$watch('vm.options', function(newVal, oldVal) {
              if (newVal && !_.isEqual(newVal, oldVal)) {
                scope.vm.onLoad(container);
              }
            }, true);

          }
        };
      });

})();